import { render } from "./RegionMangystau.vue?vue&type=template&id=04c99afa&ts=true"
import script from "./RegionMangystau.vue?vue&type=script&lang=ts"
export * from "./RegionMangystau.vue?vue&type=script&lang=ts"

import "./RegionMangystau.vue?vue&type=style&index=0&id=04c99afa&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__